/**
 * Escuyer mega menu — Beanies image behaviour:
 * - Show default collection image when hovering nav item
 * - Fade out when cursor enters the dropdown
 * - Swap to subcategory image on link hover
 * - Restore default on link leave
 */
(function () {
  'use strict';

  function wireMenuItem(menuItem) {
    if (menuItem.dataset.escuyerWired) return;
    menuItem.dataset.escuyerWired = '1';

    var attrObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'aria-expanded') return;
        var isOpen = menuItem.getAttribute('aria-expanded') === 'true';

        var dropdown = menuItem.querySelector('.header__dropdown');
        if (!dropdown) return;
        var menuBlocks = dropdown.querySelector('.menu__blocks');
        if (!menuBlocks) return;
        var previewImg = dropdown.querySelector('.mega-menu-preview__image');
        if (!previewImg) return;
        var defaultSrc = previewImg.getAttribute('data-default-src') || '';
        if (!defaultSrc) return;

        if (isOpen) {
          // Show image immediately when dropdown opens
          previewImg.src = defaultSrc;
          previewImg.style.transition = 'opacity 0.3s ease';
          previewImg.style.opacity = '1';

          // Fade out when cursor enters the dropdown inner area
          if (!dropdown.dataset.fadeWired) {
            dropdown.dataset.fadeWired = '1';

            dropdown.addEventListener('mouseenter', function () {
              previewImg.style.transition = 'opacity 0.3s ease';
              previewImg.style.opacity = '0';
            });

            dropdown.addEventListener('mouseleave', function () {
              // Restore when leaving dropdown back to nav bar
              previewImg.src = defaultSrc;
              previewImg.style.transition = 'opacity 0.3s ease';
              previewImg.style.opacity = '1';
            });

            // Wire subcategory links: swap image on hover
            var links = Array.from(dropdown.querySelectorAll('[data-stagger-first]'));
            links.forEach(function (link) {
              var imgSrc = link.getAttribute('data-img') || '';

              link.addEventListener('mouseenter', function () {
                if (!imgSrc) return;
                previewImg.src = imgSrc;
                previewImg.style.transition = 'opacity 0.3s ease';
                previewImg.style.opacity = '1';
              });

              link.addEventListener('mouseleave', function () {
                previewImg.style.transition = 'opacity 0.3s ease';
                previewImg.style.opacity = '0';
              });
            });
          }
        } else {
          // Dropdown closed — reset
          previewImg.style.opacity = '0';
        }
      });
    });

    attrObserver.observe(menuItem, { attributes: true, attributeFilter: ['aria-expanded'] });
  }

  function init() {
    document.querySelectorAll('.menu__item.grandparent').forEach(function (menuItem) {
      setTimeout(function () {
        var dropdown = menuItem.querySelector('.header__dropdown');
        if (!dropdown) return;
        var previewImg = dropdown.querySelector('.mega-menu-preview__image');
        if (previewImg && previewImg.getAttribute('data-default-src')) {
          wireMenuItem(menuItem);
        }
      }, 0);
    });

    document.addEventListener('mouseover', function (e) {
      var item = e.target.closest('.menu__item.grandparent');
      if (!item) return;
      var dropdown = item.querySelector('.header__dropdown');
      if (!dropdown) return;
      var previewImg = dropdown.querySelector('.mega-menu-preview__image');
      if (previewImg && previewImg.getAttribute('data-default-src')) {
        wireMenuItem(item);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
